import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, Validators} from '@angular/forms';
import {MailTemplateService} from './mail-template.service';
import {ToastrService} from 'ngx-toastr';

@Component({
	selector: 'kt-mail-template',
	templateUrl: './mail-template.component.html',
	styleUrls: ['./mail-template.component.scss']
})
export class MailTemplateComponent implements OnInit {
	formreg = this.fb.group({
		header: ['', Validators.required],
		body: ['', Validators.required]
	});
	forma = this.fb.group({
		header: ['', Validators.required],
		body: ['', Validators.required]
	});
	formb = this.fb.group({
		header: ['', Validators.required],
		body: ['', Validators.required]
	});
	formpark = this.fb.group({
		header: ['', Validators.required],
		body: ['', Validators.required]
	});
	constructor(private toastr: ToastrService,private fb: FormBuilder, public activeModal: NgbActiveModal, private mailService: MailTemplateService) {
	}

	ngOnInit() {
		this.getData();
	}

	getData() {
		this.mailService.getTemplate().subscribe((res) => {
			this.formreg.setValue({
				header: res.reg.header,
				body: res.reg.body
			});
			this.forma.setValue({
				header: res.accept.header,
				body: res.accept.body
			});
			this.formb.setValue({
				header: res.alreadyMember.header,
				body: res.alreadyMember.body
			});
			this.formpark.setValue({
				header: res.parking.header,
				body: res.parking.body
			});
		});
	}

	save(item?) {
		if (item=='reg') {
			this.mailService.putTemplate(1, this.formreg.getRawValue()).subscribe((res) => {
				if(res.status==200){
					this.toastr.success('A regisztrációs templatet sikeresen mentette','');
					this.activeModal.close(true);
				}
				else{
					this.toastr.error('hiba mentéskor','');
				}
			});
		}
		if (item=='tag') {
			this.mailService.putTemplate(3,this.formb.getRawValue()).subscribe((res)=>{
				if(res.status==200){
					this.toastr.success('A visszaigazoló templatet sikeresen mentette','');
					this.activeModal.close(true);
				}
				else{
					this.toastr.error('hiba mentéskor','');
				}
			})
		}
		if(item=='vissz'){
			this.mailService.putTemplate(2,this.forma.getRawValue()).subscribe((res)=>{
				if(res.status==200){
					this.toastr.success('A visszaigazoló templatet sikeresen mentette','');
					this.activeModal.close(true);
				}
				else{
					this.toastr.error('hiba mentéskor','');
				}
			})
		}
		if(item=='parking'){
			this.mailService.putTemplate(4,this.formpark.getRawValue()).subscribe((res)=>{
				if(res.status==200){
					this.toastr.success('A visszaigazoló templatet sikeresen mentette','');
					this.activeModal.close(true);
				}
				else{
					this.toastr.error('hiba mentéskor','');
				}
			})
		}
	}
}
